import BaseComponent from '@/js/core/BaseComponent'
import $ from 'jquery'

export default class Form extends BaseComponent {
  static root = '.wpcf7-form'

  selectors = {
    'inputs[]': "[type='radio']"
  }

  listeners = {
    'change @inputs': ({ target }) => {
      $(target).parents('.wpcf7-list-item')
        .addClass('checked').siblings()
        .removeClass('checked')
    }
  }

  mounted () {
    super.mounted()
    
    this.$.inputs.each((_, element) => {
      if (element.checked)
        $(element).parents('.wpcf7-list-item')
          .addClass('checked')
    })
  }
}